/* eslint-disable @typescript-eslint/no-explicit-any */
import { getUserChannel, userStore } from "@/stores/userStore";

// 配置限制
export function useConfigRestrict() {
  /**
   * 用户标签限制
   *
   * @param label_list 限制标签
   * @param label_type_limit 限制类型
   * @returns 是否符合限制
   */
  const getStatusByLabelsDeny = (
    label_list: Array<any>,
    label_type_limit: number,
  ) => {
    if (userStore?.isLogin) {
      const labels = userStore?.userInfo?.labels || [];
      if (label_type_limit == 1) {
        //排除
        for (let i = 0; i < labels.length; i++) {
          if (label_list.includes(labels[i])) {
            return false;
          }
        }
        return true;
      } else if (label_type_limit == 2) {
        //包含
        for (let i = 0; i < labels.length; i++) {
          if (label_list.includes(labels[i])) {
            return true;
          }
        }
        return false;
      }
    }
    return label_type_limit != 2;
  };
  /**
   * 总代限制
   *
   * @param deny_pack 限制范围
   * @param deny_pack_type 限制类型
   * @returns 是否符合限制
   */
  const getStatusByDeny = (
    deny_pack: Array<any>,
    deny_pack_type: number,
    init = true,
  ) => {
    let status = init;
    const { general, channel } = getUserChannel();
    const myCh = channel;
    const myGeneral = general;

    // 100: 不限制,  0: 排除渠道, 1: 包含渠道, 2: 排除总代, 3: 包含总代
    if (deny_pack_type === 100) return true;

    if (status) {
      if (deny_pack_type === 0) {
        status = !deny_pack.includes(myCh);
      }
      if (deny_pack_type === 1) {
        status = deny_pack.includes(myCh);
      }
      if (deny_pack_type === 2) {
        status = !deny_pack.includes(myGeneral);
      }
      if (deny_pack_type === 3) {
        status = deny_pack.includes(myGeneral);
      }
    }
    return status;
  };
  /**
   * 登录限制
   *
   * @param login_type 限制类型
   * @returns 是否符合限制
   */
  const getStatusByLogin = (login_type: number | string) => {
    const type = Number(login_type);
    const isLogin = userStore?.isLogin ? true : false;
    if (type == 1) {
      //登录
      return isLogin;
    } else if (type == 2) {
      //未登陆
      return !isLogin;
    }
    return true;
  };
  /**
   * 充值限制
   *
   * @param pay_type 限制类型
   * @returns 是否符合限制
   */
  const getStatusByPay = (pay_type: number | string) => {
    const type = Number(pay_type);
    const isPay = userStore?.userInfo?.is_pay ? true : false;
    if (type == 1) {
      // 充值
      return isPay;
    } else if (type == 2) {
      // 未充值
      return !isPay;
    }
    return true;
  };
  return {
    getStatusByLabelsDeny,
    getStatusByDeny,
    getStatusByLogin,
    getStatusByPay,
  };
}
